
import React from 'react';
import { FormLabel } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { MessageCircle, Facebook, Linkedin, Mail, Instagram, Twitter } from 'lucide-react';

interface ShareOptionsSectionProps {
  selectedOptions: string[];
  onOptionChange: (platform: string, checked: boolean) => void;
}

const socialPlatforms = [
  { id: "instagram", label: "Instagram", icon: Instagram },
  { id: "twitter", label: "Twitter", icon: Twitter },
  { id: "facebook", label: "Facebook", icon: Facebook },
  { id: "linkedin", label: "LinkedIn", icon: Linkedin },
  { id: "mail", label: "Email", icon: Mail },
  { id: "whatsapp", label: "WhatsApp", icon: MessageCircle }
];

export const ShareOptionsSection: React.FC<ShareOptionsSectionProps> = ({
  selectedOptions,
  onOptionChange
}) => {
  return (
    <div className="space-y-2">
      <FormLabel>Share Options</FormLabel>
      <div className="grid grid-cols-2 gap-2">
        {socialPlatforms.map((platform) => (
          <div 
            key={platform.id} 
            className="flex items-center space-x-2 rounded-md border p-3"
          >
            <Checkbox
              id={`platform-${platform.id}`}
              checked={selectedOptions.includes(platform.id)}
              onCheckedChange={(checked) => 
                onOptionChange(platform.id, checked as boolean)
              }
            />
            <label
              htmlFor={`platform-${platform.id}`}
              className="flex items-center cursor-pointer text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              <platform.icon className="h-4 w-4 mr-2" />
              {platform.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
